// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2ak8m","dragIcon":"SortableItem_dragIcon__3S-GK","disabled":"SortableItem_disabled__1LKml"};